module.exports = __webpack_public_path__ + "static/media/warning-sign.d14ce180.svg";